module.exports = '<svg width="26" height="32" viewBox="0 0 26 32"><path d="M16.034 19.171v11.226c0 .885-.718 1.604-1.604 1.604h-3.207a1.604 1.604 0 0 1-1.604-1.604V19.171H2.114c-1.989 0-2.694-1.379-1.604-2.983L10.838 1.174c1.091-1.604 2.887-1.536 3.977.035l10.328 14.978c1.09 1.568.385 2.983-1.604 2.983h-7.505z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/up-3.js
// module id = 1469
// module chunks = 14